// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KQ1A","content":"styles_content__11Z1u"};